export function getPmiColours() {
    const DISTINCT = [
      "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
      "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab"
    ];
    return DISTINCT;
  }
  
  export function getPmiConfig() {
    const groupsById = {
  

        pol_nicotine_tax: {
            type: "likert",
            label: "Support for increased tax on less harmful nicotine",
            fulltext: "Do you think it is fair to tax less harmful nicotine products at the same rate as more harmful ones?",
            keys: ["nicotine_tax__yes_pred", "nicotine_tax__no_pred", "nicotine_tax__dk_pred"],
            labels: {
              "nicotine_tax__yes_pred": "Yes, it is fair",
              "nicotine_tax__no_pred": "No, it is not fair",
              "nicotine_tax__dk_pred": "Don’t know",
            },
            polarity: {
               pos: "nicotine_tax__yes_pred",
               neg:  "nicotine_tax__no_pred",
               neu: "nicotine_tax__dk_pred",
              },
      schema:"client",
          },


        pol_cigarette_impact: {
            type: "likert",
            label: "Impact of rising non-combustible nicotine products",
            fulltext: "If the price of non-combustible nicotine products (like vapes or heated tobacco) increased, how would that affect your likelihood of switching back to traditional cigarettes?",
            keys: [
              "cig_cost__morelik_pred",
              "cig_cost__lesslik_pred",
              "cig_cost__nochange_pred",
            //   "cig_cost__donotsmoke_pred",
            ],
            labels: {
              "cig_cost__morelik_pred": "More likely to switch back to cigarettes",
              "cig_cost__lesslik_pred": "Less likely to switch back to cigarettes",
              "cig_cost__nochange_pred": "No change in my likelihood",
            //   "cig_cost__donotsmoke_pred": "Do not smoke",
            },
            polarity: {
                neg: "cig_cost__morelik_pred",
                pos: "cig_cost__lesslik_pred",
                neu: "cig_cost__nochange_pred",
              },
      schema:"client",
          },

          pol_econ_direction: {
            type: "likert",
            label: "Cost of living",
            fulltext: "Would you say that you are better off or worse off financially than you were a year ago?",
            keys: [
              "col__better_pred",
              "col__same_pred",
              "col__worse_pred",
            ],
            labels: {
              "col__better_pred": "Better",
              "col__same_pred": "About the same",
              "col__worse_pred": "Worse",
            },
            polarity: {
              pos: "col__better_pred",
              neu: "col__same_pred",
              neg: "col__worse_pred",
          },
      schema:"client",
        }
      


  
    };
  
    return { groupsById };
}

// Tab-as-config default export
export default {
  tab: "pmi",
  label: "PMI",
  get metrics() { return getPmiConfig().groupsById; },
};


